import api from './api';
import type { ContactListResponse } from '@/types';

class ContactsService {
  async searchContacts(query: string, limit = 10): Promise<ContactListResponse | null> {
    const response = await api.get<ContactListResponse>('/contacts/search', { q: query, limit });
    return response.success && response.data ? response.data : null;
  }

  async getSuggestedContacts(limit = 5): Promise<ContactListResponse | null> {
    const response = await api.get<ContactListResponse>('/contacts/suggested', { limit });
    return response.success && response.data ? response.data : null;
  }

  async getContacts(page = 1, limit = 50): Promise<ContactListResponse | null> {
    const response = await api.get<ContactListResponse>('/contacts', { page, limit });
    return response.success && response.data ? response.data : null;
  }
}

export default new ContactsService();
